import { render, staticRenderFns } from "./LoadsReport.vue?vue&type=template&id=b439a15c"
import script from "./LoadsReport.vue?vue&type=script&lang=js"
export * from "./LoadsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports